var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.canPlayLeaderboardMusic)?_c('audio',{ref:"leaderboard-music",attrs:{"src":_vm.leaderboardMusic,"autoplay":true,"preload":"auto"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }